<template>
  <div id="contenedor-presupuestos-default">
    <v-container fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            v-model="ejercicio"
            v-on:nuevoPresupuesto="registrarNuevoPresupuesto"
            >
          </tool-bar>
          <v-row>
            <btn-exportar-ejercicio
              :ejercicio="`${ejercicio}`"
              :presupuestos="getPresupuestos" />
            <btn-exportar-rango />
          </v-row>
        </v-card-text>
      </v-card>
      <!-- <pre>{{ getDetalles }}</pre> -->
      <v-row v-if="!$apollo.loading" class="mb-4">
        <v-col cols="6" md="auto">
          <v-card flat>
            <v-card-title class="py-1">{{ getTotalAutorizadoDetalles | currency }}</v-card-title>
            <v-card-subtitle>P. Autorizado</v-card-subtitle>
          </v-card>
        </v-col>
        <v-col cols="6" md="auto">
          <v-card
            flat
            :color="getColorTotalModificado"
            dark>
            <v-card-title class="py-1">
              {{ getTotalModificado | currency }}
            </v-card-title>
            <v-card-subtitle>
              <span class="mt-2">P. Modificado</span>
            </v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <v-card flat>
        <v-card-text>
          <listado :ejercicio="ejercicio" />
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoPresupuesto"
      width="95%">
      <registrar-nuevo-presupuesto
        v-if="mostrarVentanaRegistrarNuevoPresupuesto"
        v-on:cerrar="cerrarRegistrarNuevoPresupuesto">
      </registrar-nuevo-presupuesto>
    </v-dialog>
    <v-dialog
      v-if="estaPresupuesto"
      v-model="mostrarVentanaEditarPresupuesto"
      width="95%">
      <editar-presupuesto
        :presupuestoEditar="estaPresupuesto"
        v-on:cerrar="cerrarEditarPresupuesto">
      </editar-presupuesto>
    </v-dialog>
    <v-dialog
      v-if="estaPresupuesto"
      v-model="mostrarVentanaEliminarPresupuesto"
      width="600">
      <eliminar-presupuesto
        :presupuestoEliminar="estaPresupuesto"
        v-on:cerrar="cerrarRemoverPresupuesto">
      </eliminar-presupuesto>
    </v-dialog>
  </div>
</template>

<script>
import mixPresupuestos from '@/components/administracion/presupuestos/mixPresupuestos';
import TituloToolBar from './TituloToolBar.vue';
import RegistrarNuevoPresupuesto from '@/components/administracion/presupuestos/Nuevo.vue';
import BtnExportarEjercicio from '@/components/exportar/exceles/ExcelPresupuestoEjercicio.vue';
import BtnExportarRango from '@/components/exportar/exceles/ExcelPresupuestoRangoFecha.vue';
import EditarPresupuesto from '@/components/administracion/presupuestos/Editar.vue';
import EliminarPresupuesto from '@/components/administracion/presupuestos/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'PresupuestosDefault',
  mixins: [mixPresupuestos],
  components: {
    TituloToolBar,
    RegistrarNuevoPresupuesto,
    EditarPresupuesto,
    EliminarPresupuesto,
    ToolBar,
    Listado,
    BtnExportarEjercicio,
    BtnExportarRango,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoPresupuesto: false,
      mostrarVentanaEditarPresupuesto: false,
      mostrarVentanaEliminarPresupuesto: false,
      estaPresupuesto: null,
      ejercicio: Number(new Date().toISOString().substr(0, 4)),
    };
  },
  mounted() {
    eventBus.$on('editar-presupuesto', (presupuesto) => {
      this.estaPresupuesto = presupuesto;
      this.mostrarVentanaEditarPresupuesto = true;
    });
    eventBus.$on('eliminar-presupuesto', (presupuesto) => {
      this.estaPresupuesto = presupuesto;
      this.mostrarVentanaEliminarPresupuesto = true;
    });
  },
  methods: {
    registrarNuevoPresupuesto() {
      this.mostrarVentanaRegistrarNuevoPresupuesto = true;
    },
    cerrarRegistrarNuevoPresupuesto() {
      this.mostrarVentanaRegistrarNuevoPresupuesto = false;
    },
    cerrarEditarPresupuesto() {
      this.mostrarVentanaEditarPresupuesto = false;
      this.estaPresupuesto = null;
    },
    cerrarRemoverPresupuesto() {
      this.mostrarVentanaEliminarPresupuesto = false;
      this.estaPresupuesto = null;
    },
    getImporteModificado({ detalles }) {
      let total = 0;
      detalles.forEach(({ importe, modificaciones }) => {
        const sumaModificaciones = modificaciones.reduce((acc, elem) => acc + elem.importe, 0);
        const preTotal = importe + sumaModificaciones;
        total += preTotal;
      });
      return total;
    },
    getSumaImporteDetalles({ detalles }) {
      return detalles.reduce((acc, elem) => acc + elem.importe, 0);
    },
  },
  computed: {
    getPresupuestos() {
      if (!this.presupuestos) return [];
      return this.presupuestos.filter((item) => Number(item.ejercicio) === Number(this.ejercicio));
    },
    getTotalAutorizado() {
      return this.getPresupuestos.reduce((acc, elem) => acc + elem.importe, 0);
    },
    getTotalAutorizadoDetalles() {
      let total = 0;
      this.getPresupuestos.forEach((presupuesto) => {
        total += this.getSumaImporteDetalles(presupuesto);
      });
      return total;
    },
    getTotalModificado() {
      let total = 0;
      this.getPresupuestos.forEach((presupuesto) => {
        total += this.getImporteModificado(presupuesto);
      });
      return total;
    },
    getColorTotalModificado() {
      return this.getTotalAutorizadoDetalles === this.getTotalModificado ? 'success' : 'warning';
    },
  },
};
</script>

<style lang="scss">

</style>
